export class PubSub {
    subscribers: Record<string, Function[]>;
    constructor() {
        this.subscribers = {};
    }

    subscribe(key, fn) {
        if (!this.subscribers[key]) {
            this.subscribers[key] = [];
        }
        this.subscribers[key].push(fn);
    }

    notify(key, data) {
        this.subscribers[key]?.forEach(subscriber => subscriber(data));
    }
}
